import React, { useState, useEffect } from "react"
import "./map.css"

const GoogleMaps = () => {
	let expediente = window.location.pathname.split("/")[2]
	const [map, setMap] = useState(null)
	const [loading, setLoading] = useState(true)
	const [data, setData] = useState({ data1: [], data2: [] })
	let activeInfoWindow = null

	useEffect(() => {
		async function fetchData() {
			try {
				const responseDetail = await fetch(`/api/query/detail?id=${expediente}`)
				const dataDetail = await responseDetail.json()

				const lastThreeDigits = expediente.slice(-3)
				const responseActiveUser = await fetch(
					`/api/query/activeuser?lastThree=${lastThreeDigits}`
				)
				const dataActiveUser = await responseActiveUser.json()

				if (dataDetail !== null && dataActiveUser !== null) {
					setData({ ...dataDetail, ...dataActiveUser })
				}
			} catch (error) {
				console.log(error)
			}
		}
		fetchData()
	}, [expediente])

	useEffect(() => {
		async function fetchData() {
			try {
				const response1 = await fetch(`/api/query/coordenates`)
				const data1 = await response1.json()
				const response2 = await fetch(`/api/query/coordenadas`)
				const rawdata2 = await response2.json()
				const filteredData2 = rawdata2
					.filter(point => point.coordenadas_latitud && point.coordenadas_longitud)
					.map(point => ({
						lat: parseFloat(point.coordenadas_latitud),
						lng: parseFloat(point.coordenadas_longitud),
						...point,
					}));
	
				setData({
					data1: data1.map(point => ({
						lat: parseFloat(point.coordenadas_latitud),
						lng: parseFloat(point.coordenadas_longitud),
						...point,
					})),
					data2: filteredData2
				});
			} catch (error) {
				console.error(error)
			} finally {
				setLoading(false)
			}
		}
		fetchData()
	}, [])

	useEffect(() => {
		const onLoad = () => {
			const map = new window.google.maps.Map(document.getElementById("map"), {
				center: { lat: 40.416775, lng: -3.70379 },
				zoom: 10,
			})

			const bounds = new window.google.maps.LatLngBounds()

			map.addListener("click", () => {
				if (activeInfoWindow) {
					activeInfoWindow.close()
				}
			})

			const addMarker = (point, color, content) => {
				if (!point.lat || !point.lng || isNaN(point.lat) || isNaN(point.lng)) {
					console.warn("Invalid coordinates:", point.lat, point.lng)
					return
				}
				const position = new window.google.maps.LatLng(point.lat, point.lng)
				const marker = new window.google.maps.Marker({
					position,
					map,
					icon: `http://maps.google.com/mapfiles/ms/icons/${color}-dot.png`,
				})

				const infowindow = new window.google.maps.InfoWindow({ content })

				marker.addListener("click", () => {
					if (activeInfoWindow) {
						activeInfoWindow.close()
					}
					infowindow.open(map, marker)
					activeInfoWindow = infowindow
				})

				bounds.extend(position)
			}

			data.data1.forEach((point) => {
				const content = `
				<div>
				  <p><strong>No. Notificación: </strong>${point.noNotificacion}</p>
				  <p><strong>No. Acta de Comprobación: </strong>${point.noActaComprobacion}</p>
				  <p><strong>Observaciones: </strong>${point.observaciones}</p>
				  <p><strong>Estado: </strong>${point.estado}</p>
                  <p><strong>Levantado por: </strong>${point.fullname}</p>
                  ${point.ImagenesIns ? `<img src="${point.ImagenesIns.path1}" alt="Imagen" style="max-width: 100%; height: auto;" />` : ""}
				</div>
			  `
				addMarker(point, "red", content)
			})

			data.data2.forEach((point) => {
					const content = `
					<div>
					  <p><strong>Expediente: </strong>${point.expediente}</p>
					  <p><strong>Nombre Proyecto: </strong>${point.nombre}</p>
					  <p><strong>Tipo de Proyecto: </strong>${point.tipoProyecto}</p>
					  <p><strong>Estado: </strong>${point.estado}</p>
					</div>
				  `
					addMarker(point, "blue", content)
			})

			map.fitBounds(bounds)
			setMap(map)
		}

		if (!window.google) {
			const script = document.createElement("script")
			script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyA7Uv3tKCaMzfuuus0zPv59WVMbF-Iodwc`
			script.onload = onLoad
			document.head.appendChild(script)
		} else {
			onLoad()
		}
	}, [data])

	return (
		<div>
			{loading && <p>Loading...</p>}
			<div id="map" style={{display: loading ? 'none' : 'block'}}></div>
		</div>
	);	
}

export default GoogleMaps
